<template>
 <div>
    <b-button v-if="this.ticket.gestors.some(g => g.codi_xarxa == this.user.id)" variant="success" size="sm" v-b-modal.modalAddManager>
     <font-awesome-icon :icon="['fas', 'plus']"/>
     Afegir gestors
    </b-button>
    <b-dropdown v-else variant="success" size="sm" right>
     <template #button-content>
        <font-awesome-icon :icon="['fas', 'plus']"/> Afegir gestors
      </template>
      <b-dropdown-item @click="followTicket()">Afegir-me com a gestor</b-dropdown-item>
      <b-dropdown-item v-b-modal.modalAddManager>Afegir un altre gestor</b-dropdown-item>
    </b-dropdown>
    <!-- Modal Component -->
    <b-modal id="modalAddManager" centered ref="modalAddManager"  title="Afegir nou gestor">
      Gestors a afegir:
      <v-select multiple v-model="addedManagers"
      placeholder="-- Selecciona els gestors que vulguis afegir --"
      :options="this.managers.filter(gestor => !ticket.gestors.some(ticket_gestor => ticket_gestor.codi_xarxa == gestor))"/>
      <div slot="modal-footer" class="w-100">
        <b-btn size="sm" class="float-right" variant="primary" @click.prevent="save">
          <font-awesome-icon :icon="['fas', 'check']"/>
          Desar
        </b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>

export default {
  computed: {
    managers () {
      return this.$store.state.managers
    },
    user () {
      return this.$store.getters.getUser
    }
  },
  data () {
    return {
      addedManagers: null
    }
  },
  props: {
    ticket: {
      required: true,
      type: Object
    }
  },
  methods: {
    followTicket () {
      this.addedManagers = [this.user.id]
      this.save()
    },
    save () {
      if (this.isNullOrUndefined(this.addedManagers)) {
        this.notifyError('Falta informació', 'Has d\'escollir gestors a assignar')
      } else {
        this.$refs.modalAddManager.hide()
        // Si afegeixen usuaris i està pendent d'aprovació canviem l'estat a Oberta
        if (this.ticket.estat.nom === 'pending') {
          this.$store.dispatch('managerTransitionTicket', {
            ticket_id: this.ticket.id,
            codi_xarxa: this.$store.getters.getUser.id,
            managers: this.addedManagers,
            transition: 'accept'
          }).then(() => {
            this.addedManagers = null
            return this.addedManagers
          }, {})
        } else {
          this.$store.dispatch('managerFollowTicket', {
            ticketId: this.ticket.id,
            managers: this.addedManagers,
            usuari: this.$store.getters.getUser.id
          }).then(() => {
            this.addedManagers = null
            return this.addedManagers
          }, {})
        }
      }
    }
  },
  created () {
    this.$store.dispatch('fetchGroupManagers', this.ticket.grup.id)
  }
}
</script>

<style scoped>
</style>
